import { ListingModalOptionWrapper } from "./ListingModalOptionWrapper";
import { ListingModalOptionHeader } from "./ListingModalOptionHeader";
import { ListingModalOptionTitle } from "./ListingModalOptionTitle";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import { useListingModalPlanOptionsContext } from "./ListingModalPlanOptionsProvider";
import { useSnackbarContext } from "../../../../global/snackbar/SnackbarProvider";
import { ErrorSnackbar, Snackbar } from "../../../../global/snackbar";
import { useListingModalOptionContext } from "./ListingModalOptionProvider";
import { ListingType } from "../../../../../enums/listing/TitleTypes";
import { formatPrice } from "../../../../../lib/generic";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "../../../../global/ui/buttons";

type ListingModalOneTimeOptionProps = {
  disabled?: boolean;
  useSecondaryButton?: boolean;
};

export const ListingModalOneTimeOption = ({
  disabled,
  useSecondaryButton = true,
}: ListingModalOneTimeOptionProps) => {
  const { handleOneTimePurchase } = useListingModalPlanOptionsContext();
  const { setSnackbar } = useSnackbarContext();
  const { state, dispatch } = useListingModalOptionContext();
  const trainingPlan = useSelector((state: RootState) => state.trainingPlan);
  const title =
    trainingPlan.listingType === ListingType.ASSESSMENT
      ? "Add this assessment to your library for a one-time fee. Complete any time."
      : "Get lifetime access to this plan for a one-time fee";
  const buttonText =
    trainingPlan.listingData.price > 0
      ? `Buy now for €${formatPrice(trainingPlan.listingData.price)}`
      : "Unlock for free";
  let headerText = title;

  if (trainingPlan.listingData.price === 0) {
    headerText = "Limited offer. Access this training plan for free";
  }

  const joinOneTimeHandler = async () => {
    try {
      dispatch({ isLoading: true });
      await handleOneTimePurchase();

      if (trainingPlan.listingData.price === 0) {
        setSnackbar(<Snackbar message={"Listing added to your library"} />);
      }
    } catch (e) {
      const error = e as Error;
      setSnackbar(<ErrorSnackbar message={error.message} />);
    } finally {
      dispatch({ isLoading: false });
    }
  };

  return (
    <ListingModalOptionWrapper>
      <ListingModalOptionHeader>
        <ListingModalOptionTitle className={"text-left"}>
          {headerText}
        </ListingModalOptionTitle>
      </ListingModalOptionHeader>

      {useSecondaryButton ? (
        <AppSecondaryButton
          disabled={state.isLoading || disabled}
          onClick={() => void joinOneTimeHandler()}
          className={"w-full text-[14px] md:text-[12px] xl:text-[14px]"}
        >
          {buttonText}
        </AppSecondaryButton>
      ) : (
        <AppPrimaryButton
          disabled={state.isLoading || disabled}
          onClick={() => void joinOneTimeHandler()}
          className={"w-full text-[14px] md:text-[12px] xl:text-[14px]"}
        >
          {buttonText}
        </AppPrimaryButton>
      )}
    </ListingModalOptionWrapper>
  );
};
